var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form flex" },
    [
      _vm._l(_vm.auditBpNodeList, function(auditBpNode, index) {
        return _vm.auditBpNodeList.length > 0
          ? [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v(_vm._s(auditBpNode.nodeDefName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-3x" }, [
                  _c(
                    "div",
                    {
                      staticClass: "inline-block",
                      staticStyle: {
                        width: "270px",
                        "border-bottom": "1px solid #dadada"
                      }
                    },
                    _vm._l(auditBpNode.auditBpStaffList, function(
                      auditBpStaff
                    ) {
                      return _c(
                        "el-tag",
                        {
                          key: auditBpStaff.no,
                          staticClass: "mr5 mb5",
                          attrs: { closable: "" },
                          on: {
                            close: function($event) {
                              _vm.removeAuditStaff(auditBpNode, auditBpStaff.no)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(auditBpStaff.name))])]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                    attrs: { title: "选择" },
                    on: {
                      click: function($event) {
                        _vm.selectAuditStaffs(auditBpNode, index)
                      }
                    }
                  })
                ])
              ])
            ]
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.auditBpNodeList.length <= 0 && _vm.dataCallback
        ? _c("div", { staticClass: "no-data" }, [
            _c("i", {
              staticClass: "icon iconfont icon-zanwushuju mr10",
              staticStyle: { "font-size": "58px", "vertical-align": "middle" }
            }),
            _vm._v(" "),
            _c("span", {}, [_vm._v("未设置审批节点")])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44e8e34f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e8e34f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/oaAudit/MerchtAuditBpNodeList.vue
// module id = 2539
// module chunks = 0